import { Dialog } from 'vant';
import { getGameUrlApiErrorDialogBody } from '@/utils/gameUrlApiError';

/** Shared Vant class + overlay; styles live in `src/scss/style.scss`. */
export const STYLED_APP_DIALOG_CLASS = 'game-url-error-dialog';

const overlayStyle = {
  background: 'rgba(15, 23, 42, 0.52)',
  backdropFilter: 'blur(4px)',
  WebkitBackdropFilter: 'blur(4px)',
};

function styledDialogCore(isEn, title, message, confirmButtonText) {
  return {
    title,
    message,
    messageAlign: 'left',
    confirmButtonText,
    confirmButtonColor: '#DD4DD1',
    className: STYLED_APP_DIALOG_CLASS,
    getContainer: 'body',
    overlayStyle,
  };
}

/**
 * Single-button styled alert (errors, notices, limit messages).
 * @param {string} message
 * @param {'en'|'mm'} lang
 * @param {{ title?: string, confirmButtonText?: string }} [options]
 */
export function showStyledAppAlert(message, lang = 'en', options = {}) {
  const isEn = lang === 'en';
  const title =
    options.title != null
      ? options.title
      : isEn
        ? 'Notice'
        : 'အကြောင်းကြားချက်';
  const confirmButtonText =
    options.confirmButtonText != null
      ? options.confirmButtonText
      : isEn
        ? 'OK'
        : 'ကောင်းပြီ';
  const body =
    message ||
    (isEn ? 'Please try again.' : 'ထပ်စမ်းကြည့်ပါ။');
  return Dialog.alert(styledDialogCore(isEn, title, body, confirmButtonText));
}

/**
 * Two-button styled dialog (e.g. disclaimer + “Play the game”).
 * Confirm resolves; cancel rejects (Vant default).
 */
export function showStyledAppConfirm(message, lang = 'en', options = {}) {
  const isEn = lang === 'en';
  const title =
    options.title != null
      ? options.title
      : isEn
        ? 'Notice'
        : 'အကြောင်းကြားချက်';
  return Dialog.confirm({
    ...styledDialogCore(
      isEn,
      title,
      message || '',
      options.confirmButtonText != null
        ? options.confirmButtonText
        : isEn
          ? 'OK'
          : 'ကောင်းပြီ',
    ),
    showCancelButton: true,
    cancelButtonText:
      options.cancelButtonText != null
        ? options.cancelButtonText
        : isEn
          ? 'Close'
          : 'ပိတ်မည်',
    cancelButtonColor: '#646566',
  });
}

/**
 * Alert-style modal for failed game launch API calls (includes `description` when present).
 */
export function showGameUrlErrorDialog(error, lang = 'en', fallbackMessage) {
  const isEn = lang === 'en';
  const body = getGameUrlApiErrorDialogBody(
    error,
    fallbackMessage,
    isEn ? 'en' : 'mm',
  );
  Dialog.alert(
    styledDialogCore(
      isEn,
      isEn ? 'Cannot open game' : 'ဂိမ်းဖွင့်မရပါ',
      body,
      isEn ? 'OK' : 'ကောင်းပြီ',
    ),
  );
}

/** Client-side validation / empty success payload (no axios error object). */
export function showGameUrlClientError(message, lang = 'en') {
  const isEn = lang === 'en';
  Dialog.alert(
    styledDialogCore(
      isEn,
      isEn ? 'Cannot open game' : 'ဂိမ်းဖွင့်မရပါ',
      message || (isEn ? 'Please try again.' : 'ထပ်စမ်းကြည့်ပါ။'),
      isEn ? 'OK' : 'ကောင်းပြီ',
    ),
  );
}
